import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import Layout from "@/components/Layout";
import { BookOpen, ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data.posts)).catch(() => {}); }, []);

  const open = async (slug) => {
    const r = await api.get(`/blog/${slug}`);
    setActive(r.data);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (active) {
    return (
      <Layout>
        <article className="max-w-3xl mx-auto px-5 sm:px-8 py-12">
          <button data-testid="blog-back" onClick={() => setActive(null)} className="text-sm text-lawn font-semibold mb-6">← Back to blog</button>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-lawn">{active.category}</span>
          <h1 className="font-display text-4xl font-extrabold text-lawn-ink mt-3">{active.title}</h1>
          <img src={active.image} alt={active.title} className="w-full h-72 object-cover rounded-2xl mt-6" />
          <div className="prose mt-6 text-lawn-ink/80 leading-relaxed whitespace-pre-line">{active.content}</div>
        </article>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="hero-gradient grain text-white">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 py-14">
          <span className="inline-flex items-center gap-2 bg-white/10 border border-white/15 rounded-full px-4 py-1.5 text-xs font-semibold"><BookOpen className="w-3.5 h-3.5 text-gold" /> LawnLink Learn</span>
          <h1 className="font-display text-5xl font-extrabold mt-5">Lawn care tips & guides</h1>
          <p className="text-white/60 mt-3 max-w-lg">Expert advice to keep your yard thriving all year round — powered by our AI SEO Agent.</p>
        </div>
      </div>
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {posts.map((post) => (
          <button key={post.slug} data-testid={`blog-post-${post.slug}`} onClick={() => open(post.slug)} className="card-hover bg-white border border-border rounded-2xl overflow-hidden text-left">
            <img src={post.image} alt={post.title} className="w-full h-44 object-cover" />
            <div className="p-6">
              <span className="text-xs font-bold uppercase tracking-wide text-lawn">{post.category}</span>
              <h3 className="font-display font-bold text-lg text-lawn-ink mt-2 leading-tight">{post.title}</h3>
              <p className="text-sm text-muted-foreground mt-2">{post.excerpt}…</p>
              <span className="inline-flex items-center gap-1 text-sm text-lawn font-semibold mt-3">Read more <ArrowRight className="w-4 h-4" /></span>
            </div>
          </button>
        ))}
      </div>
    </Layout>
  );
}
